module.exports = __webpack_public_path__ + "9fef8d0a3de96df8981fbf2e934a0f3d.svg";